<template lang="pug">
  b-row.loading-page(v-if="loading")
    b-col(align-self="center")
      font-awesome-icon.fa-pulse(icon="spinner") 
</template>

<script>
export default {
  data: () => ({
    loading: false
  }),
  mounted () {
    const vm = this;
    vm.$root.$on('APP_SET_LOADER', function (load) {
      vm.loading = load;
    });
  },
  methods: {
    start () {
      this.loading = true;
    },
    finish () {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(43, 40, 40, 0.6);
  text-align: center;
  font-size: 30px;
  font-family: sans-serif;
  z-index: 9999;
}
.fa-pulse{
  font-size: 55px;
  color: #FFF;
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue